import type { MfaFactor } from './port'

/** What to call a factor. The `kind` is the app's vocabulary, not Firebase's. */
export function labelFor(factor: MfaFactor): string {
  const name = factor.kind === 'totp' ? 'Authenticator app' : 'Text message'
  // The hint is a masked phone number — the only thing that tells two phone
  // factors apart. It never leaves the screen: `factor_type` carries the KIND
  // to analytics, and `vocabulary.ts` refuses every key that could carry a hint.
  //
  // **Only when it ADDS something.** Firebase's `displayName` for a TOTP factor
  // is routinely "Authenticator app", which is the name this function already
  // chose — so the old unconditional append rendered "Authenticator app
  // (Authenticator app)" on every account with an authenticator. Caught in a
  // browser, on a real multi-factor account; no unit test could see it, because
  // every fixture gave TOTP a distinct hint or none.
  // Truthiness deliberately: `hint` is `string | null | undefined`, and an
  // empty string adds nothing either.
  const adds = Boolean(factor.hint) && factor.hint!.trim() !== '' && factor.hint !== name
  return adds ? `${name} (${factor.hint})` : name
}
